// MOXIE: Product card — size picker hover + add-to-cart
// Replica de assets/custom_brand_card_quick_add.js (mic-little-mic-theme) con namespaces mox-card-*.
//
// Desktop: hover mencana el overlay (puro CSS, ver _card_product.scss). Este JS no muestra/oculta.
// Mobile: botón "+" abre un bottom sheet global anclado al <body>, evitando que `transform` de
//         ancestros rompa `position:fixed`.
// Click en talla (en overlay desktop o en sheet mobile) → POST /cart/add.js con `sections`
//         (mismo patrón que product-form.js) + dispatchEvent('cart:update') con sections para
//         morph del drawer sin GET /cart.js ni sectionRenderer extra.
(function () {
  const MOBILE_BP = 750;

  /** @type {HTMLDivElement|null} */ let sheet = null;
  /** @type {HTMLDivElement|null} */ let sheetBackdrop = null;
  /** @type {Element|null} */ let activeCard = null;

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'mox-card-sheet';
    sheet.innerHTML =
      '<p class="mox-card-sheet__label">Selecciona tu talla</p>' +
      '<div class="mox-card-sheet__list"></div>' +
      '<div class="mox-card-sheet__confirm">Agregado a tu carrito</div>';

    sheetBackdrop = document.createElement('div');
    sheetBackdrop.className = 'mox-card-sheet__backdrop';
    sheetBackdrop.addEventListener('click', closeSheet);

    document.body.appendChild(sheetBackdrop);
    document.body.appendChild(sheet);
  }

  /** @param {Element} cardEl */ function openSheet(cardEl) {
    if (!sheet) buildSheet();
    if (!sheet || !sheetBackdrop) return;

    activeCard = cardEl;

    const sourceList = cardEl.querySelector('.mox-card-sizes__list');
    const targetList = sheet.querySelector('.mox-card-sheet__list');
    if (targetList) targetList.innerHTML = sourceList ? sourceList.innerHTML : '';

    sheet.classList.remove('mox-card-sheet--added');
    sheet.classList.add('mox-card-sheet--open');
    sheetBackdrop.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    if (!sheet || !sheetBackdrop) return;
    sheet.classList.remove('mox-card-sheet--open');
    sheetBackdrop.classList.remove('is-visible');
    document.body.style.overflow = '';
    activeCard = null;
  }

  /** IDs de sección del drawer/iconos — alineado con product-form.js */
  function getCartItemSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        ids.push(item.dataset.sectionId);
      }
    });
    return ids;
  }

  // ── Un solo listener delegado para "+" y talla ─────────────────────────────
  document.addEventListener(
    'click',
    (e) => {
      const target = e.target.closest('.mox-card-quick-btn, .mox-card-sizes__btn');
      if (!target) return;

      if (target.matches('.mox-card-quick-btn')) {
        handleQuickBtnClick(e, target);
      } else {
        handleSizeClick(e, target);
      }
    },
    true
  );

  /** @param {MouseEvent} e @param {Element} btn */
  function handleQuickBtnClick(e, btn) {
    if (window.innerWidth >= MOBILE_BP) return;

    e.preventDefault();
    e.stopPropagation();

    const cardEl = btn.closest('product-card');
    if (!cardEl) return;

    if (activeCard === cardEl && sheet?.classList.contains('mox-card-sheet--open')) {
      closeSheet();
    } else {
      openSheet(cardEl);
    }
  }

  /** @param {MouseEvent} e @param {Element} btn */
  async function handleSizeClick(e, btn) {
    if (btn.disabled) return;

    const inSheet = !!btn.closest('.mox-card-sheet');
    const inCard = !!btn.closest('.mox-card-sizes');
    if (!inSheet && !inCard) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const list = btn.closest('.mox-card-sheet__list, .mox-card-sizes__list');
    list?.querySelectorAll('.mox-card-sizes__btn--selected').forEach((b) =>
      b.classList.remove('mox-card-sizes__btn--selected')
    );
    btn.classList.add('mox-card-sizes__btn--selected');
    btn.setAttribute('aria-busy', 'true');

    const sizesEl = btn.closest('.mox-card-sizes');

    let closeTimeoutId = 0;
    if (inSheet && sheet) {
      sheet.classList.add('mox-card-sheet--added');
      closeTimeoutId = setTimeout(closeSheet, 1500);
    } else {
      sizesEl?.classList.add('mox-card-sizes--added');
      closeTimeoutId = setTimeout(() => {
        sizesEl?.classList.remove('mox-card-sizes--added');
        btn.classList.remove('mox-card-sizes__btn--selected');
      }, 1500);
    }

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    const sectionIds = getCartItemSectionIds();
    if (sectionIds.length) {
      formData.append('sections', sectionIds.join(','));
    }

    const cartAddUrl = window.Theme?.routes?.cart_add_url ?? '/cart/add.js';

    try {
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const data = await res.json();

      if (!res.ok || data.status) {
        clearTimeout(closeTimeoutId);
        btn.classList.remove('mox-card-sizes__btn--selected');
        if (inSheet && sheet) {
          sheet.classList.remove('mox-card-sheet--added');
        } else {
          sizesEl?.classList.remove('mox-card-sizes--added');
        }
        return;
      }

      btn.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          composed: true,
          detail: {
            resource: data,
            sourceId: 'mox-card-quick-add',
            data: {
              source: 'product-form-component',
              itemCount: 1,
              variantId,
              sections: data.sections,
            },
          },
        })
      );
    } catch (_) {
      clearTimeout(closeTimeoutId);
      btn.classList.remove('mox-card-sizes__btn--selected');
      if (inSheet && sheet) {
        sheet.classList.remove('mox-card-sheet--added');
      } else {
        sizesEl?.classList.remove('mox-card-sizes--added');
      }
    } finally {
      btn.removeAttribute('aria-busy');
    }
  }
})();
